const ANIMATION_SETTINGS = {
  DURATION: Infinity,
  FPS: 24,
  SPEED: 1,
  UPDATE_INTERVAL: 1000 / 24, // Based on FPS
};

export class AnimationController {
  constructor() {
    this.lastFrameTime = 0;
    this.timeSinceLastUpdate = 0;
    this.pauseStartTime = 0;
    this.totalPausedTime = 0;
    this.frame = 0;
    this.isPaused = false;
    this.req = null;
    this.fpsUpdateInterval = 200; // Update FPS every 500ms
    this.lastFpsUpdate = 0;
    this.framesSinceLastUpdate = 0;
    this.currentFps = 0;
  }

  reset() {
    this.lastFrameTime = 0;
    this.timeSinceLastUpdate = 0;
    this.totalPausedTime = 0;
    this.pauseStartTime = 0;
    if (this.req) {
      cancelAnimationFrame(this.req);
    }
    this.lastFpsUpdate = 0;
    this.framesSinceLastUpdate = 0;
    this.currentFps = 0;
  }

  prepareFrame(currentTime) {
    if (!this.lastFrameTime) this.lastFrameTime = currentTime;

    // Adjust currentTime by subtracting total paused time
    const adjustedTime = currentTime - this.totalPausedTime;
    const secondsElapsed = adjustedTime / 1000;

    if (secondsElapsed > ANIMATION_SETTINGS.DURATION) return false;

    if (!this.isPaused) {
      if (this.pauseStartTime > 0) {
        // Coming out of pause - update total paused time
        this.totalPausedTime += currentTime - this.pauseStartTime;
        this.pauseStartTime = 0;
      }

      const deltaTime =
        (currentTime - this.lastFrameTime) * ANIMATION_SETTINGS.SPEED;
      this.timeSinceLastUpdate += deltaTime;

      this.lastFrameTime = currentTime;
    } else if (this.pauseStartTime === 0) {
      // Just paused - record the pause start time
      this.pauseStartTime = currentTime;
    }

    // Calculate FPS
    this.framesSinceLastUpdate++;
    if (currentTime - this.lastFpsUpdate >= this.fpsUpdateInterval) {
      this.currentFps = Math.round(
        (this.framesSinceLastUpdate * 1000) /
          (currentTime - this.lastFpsUpdate),
      );
      this.framesSinceLastUpdate = 0;
      this.lastFpsUpdate = currentTime;
    }

    let steps = 0;
    if (!this.isPaused) {
      steps = Math.floor(
        this.timeSinceLastUpdate / ANIMATION_SETTINGS.UPDATE_INTERVAL,
      );
    }

    return {
      steps,
      adjustedTime,
    };
  }

  postUpdate(steps) {
    this.frame += steps;
    this.timeSinceLastUpdate -= steps * ANIMATION_SETTINGS.UPDATE_INTERVAL;
  }

  togglePlayPause() {
    this.isPaused = !this.isPaused;
    if (!this.isPaused) {
      // Reset timing variables when unpausing
      this.lastFrameTime = 0;
      this.timeSinceLastUpdate = 0;
    }
  }
}
